import styled from 'styled-components';
import media from 'styled-media-query';
import { MDBContainer } from 'mdbreact';

export const Container = styled(MDBContainer)`
  margin: 0 auto;
  max-width: calc(100% - 224px) !important;
  box-sizing: border-box;
  position: relative;
  overflow-wrap: break-word;

  ${media.lessThan('medium')`
    max-width: 100% !important;
  `}
`;

export const BreadcrumbWrapper = styled.div`
  margin-bottom: 32px;
  width: 100%;
`;

export const TitleContainer = styled.div`
  margin-bottom: 48px;
  width: 100%;
`;
